<template>
    <div class="toggle-alert toggle-alert--progress-modal">
        <div class="modal-content">
            <div v-if="!occurrenceSent && !occurrenceError" id="progress-modal" class="progress-modal card bg-orange-gradLight">
                <button class="btn-close" @click="onCancel">
                    <img :src="icClose" alt="close">
                </button>

                <h1 class="occurrence text-center text-orange">
                    Ajuda
                </h1>

                <p class="sub-title">
                    Por favor, preenche os campos abaixo.
                </p>

                <form onkeydown="return event.key != 'Enter';" class="occurrence">
                    <div class="flex">
                        <div class="w-full input-container">
                            <label class="font-body">motivo*</label>
                            <div class="input-box occurrence" style="border: 0">
                                <select
                                    :name="occurrenceTypes.label"
                                    v-model="motive"
                                    class="form-control contact-container"
                                >
                                    <option
                                        v-for="(option, key) in occurrenceTypes"
                                        :key="key"
                                        :value="option"
                                    >
                                        {{ option.label }}
                                    </option>
                                </select>
                            </div>
                            <span class="text-danger error" v-if="formError.motive && Object.keys(formError.motive).length > 0">{{ formError.motive[0] }}</span>
                        </div>
                    </div>
                    <div class="flex-col">
                        <div class="input-container w-full mt-4">
                            <label>descrição*</label>
                            <div class="input-box occurrence">
                                <textarea @input="updateCharCount" maxlength="50" style="resize: none;" class="contact-container-textarea" v-model="description" name="mensage" id="contact-us-field" cols="30" rows="8" placeholder="Mensagem"></textarea>
                            </div>
                            <span class="text-danger error" v-if="formError.description && formError.description.length > 0">{{ formError.description[0] }}</span>
                        </div>
                        <div class="flex space-between">
                            <div class="w-full input-container input-small">
                                <p class="mandatory-field text-center bottom-text lg:text-left">*campos obrigatórios</p>
                            </div>
                            <div class="w-full input-container input-small">
                                <p class="mandatory-field text-center bottom-text lg:text-right">{{ textareaCounter }}/50 CARACTERES</p>
                            </div>

                        </div>
                    </div>
                    <div class="modal-bottom double">
                        <div class="text-center">
                            <button class="recover text-orange" @click="onCancel"><strong>Cancelar</strong></button>
                        </div>
                        <div class="text-center">
                            <button class="btn-bg" :class="{'disabled': isLoading}" :disabled="isLoading"  @click="onConfirm">Enviar</button>
                        </div>
                    </div>
                </form>
            </div>
            <div v-else-if="occurrenceSent" id="progress-modal" class="progress-modal card bg-orange-gradLight">
                <button class="btn-close" @click="onCancel">
                    <img :src="icClose" alt="close">
                </button>

                <img :src="icOccurrenceSuccess" alt="Enviado com sucesso">

                <h1 class="text-center text-orange">Enviado com sucesso</h1>
                <p class="sub-title">
                    {{ successMesage }}
                </p>
            </div>
            <div v-else id="progress-modal" class="progress-modal card bg-orange-gradLight">
                <button class="btn-close" @click="onCancel">
                    <img :src="icClose" alt="close">
                </button>

                <img :src="icError" alt="Enviado com sucesso">

                <h1 class="text-center text-orange">Ocorrência não submetida</h1>
                <p class="sub-title">
                    Ocorreu um erro com a tua ocorrência. Por favor, tenta mais tarde.
                </p>

                <div class="text-center">
                    <button class="btn-bg" :class="{'disabled': isLoading}" @click="onCancel">Voltar à página</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { log } from '../../../../public/vendor/datatables-plugins/pdfmake/pdfmake';
import icClose from '../../../svg/ic_close_orange.svg'
import icError from '../../../svg/ic_error.svg'
import icOccurrenceSuccess from '../../../svg/ic_occurrence_success.svg'

const defaultSuccessMessage = 'Enviamos a comunicação para Sushi at Home, responderemos tão breve quanto possível.';

export default {
    props: {
        orderId: {
            required: true
        },
        storeId: {
            required: true
        },
        externalClientId: {
            required: true,
        },
        phoneCode: {
            required: true,
        },
        phoneNumber: {
            required: true,
        },
        userName: {
            required: true,
        }
    },
    data() {
        return{
            occurrenceSent: false,
            motive: null,
            description: null,
            formError: {
                'motive': [],
                'description': [],
            },
            isLoading: false,
            icClose,
            icError,
            icOccurrenceSuccess,
            occurrenceTypes: [],
            successMesage: null,
            occurrenceError: false,
            textareaCounter: 0,
        }
    },
    created(){
        this.$axios.get('/api/occurrence-types/')
            .then((response) => {
                this.occurrenceTypes = response.data.data
            })
            .catch(() => {
                this.occurrenceError = true;
            });
    },
    methods: {
        updateCharCount(e){
            this.textareaCounter = e.target.value.length
        },
        bodyOverflow() {
            document.querySelector('html').classList.toggle('no-scroll');
            document.querySelector('body').classList.toggle('no-scroll');
        },
        resetFormFields(){
            // Clear up form fields
            this.motive = null;
            this.description = null;

            // Clear up form errors
            this.formError.motive = [];
            this.formError.description = [];
        },
        resetFormErrors(){
            this.formError.motive = [];
            this.formError.description = [];
        },
        onCancel(){
            document.querySelector('html').classList.remove('no-scroll');
            document.querySelector('body').classList.remove('no-scroll');

            this.resetFormFields();
            this.$emit('cancel')
        },
        onConfirm(e){
            e.preventDefault();
            this.resetFormErrors();

            if(!this.motive) this.formError.motive = [ "Campo obrigatório." ]
            if(!this.description) this.formError.description = [ "Campo obrigatório." ]

            if(this.motive && this.description) {

                this.isLoading = true;

                const payload = {
                    occurrence_type_id: this.motive?.id,
                    order_id: this.orderId,
                    store_id: this.storeId,
                    text: this.description,
                    external_client_id: this.externalClientId,
                    client_phone_number_code: this.phoneCode,
                    client_phone_number: this.phoneNumber,
                    client_name: this.userName
                }

                this.$axios.post('/api/occurrence', payload)
                    .then((response) => {
                        this.isLoading = false;
                        this.occurrenceSent = true;
                        this.successMesage = response.data.message ? response.data.message : defaultSuccessMessage
                    })
                    .catch((error) => {
                        this.occurrenceError = true;
                        this.isLoading = false;
                    });
            }

        },
    },
}

</script>
